import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../../generics/WaitingModal';
import swal from 'sweetalert';
import RaisedButton from 'material-ui/RaisedButton';
import Help from '../../generics/help';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { Table } from 'react-bootstrap';

var Config = require('../../../config');


class StoreUnits extends Component{
	constructor(props){
		super(props);

		this.validateInput = this.validateInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.changeEquipment = this.changeEquipment.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.addToList = this.addToList.bind(this);

		this.state = {
			unit: [], 
			unit_number:"",
			unit_id:"",
			code_component:"",
			component_number:"",
			code_component_list:[],
			value:"",
			suggestions:[],
			equipment_id:"",
		    equipment:[],
		    location_id:"",
		    location:[], 
			list:[],
			equipment_ubication:[]
		}
	}

	componentDidMount(){
		this.getEquipments();

	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); 
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			this.validateInput(e);
			this.waiting_modal.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'units/storage_ubication?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+
					'&unit_number='+e.target.value, {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.waiting_modal.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(msg=>{
						swal("Error", msg, 'error')
					});

					document.getElementById('unit_number').focus();
				}
			})
			.then(response=>{
				if(response !== undefined){
					this.setState({
						code_component_list: response
					})
					
				}

			})

		}
	}

	handleChange(event){
		this.setState({[event.target.name] : event.target.value});

		var control = document.getElementById(event.target.name);
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

	}

	onSearch(e){
		if(e.length > 0){
			var component = e[0].code;
			var number = e[0].component_number;
			this.setState({
	   			code_component: component,
				component_number: number,
				unit_id:e[0].id
	   		});
		}
	}

	isValidSearch(){
	    let isFormValid = true;
	    const unit_number = document.getElementById('unit_number');

    	const isInputValid2 = this.showCtrlError(unit_number.name);
      	if (!isInputValid2) {
        	isFormValid = false;
    	}

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	getEquipments() {
		this.waiting_modal.handleShow('Cargando...');
		
		fetch(Config.default.apiGateway.URL+'storage_ubication/actives?hf_id='+sessionStorage.getItem('health_facilities_id'),{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res =>{
			this.waiting_modal.handleClose();

			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(result){
					swal("Error", result, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var equipment = [];

				response.map((res)=>{
					equipment.push({
						id:res.equipment_id,
						name:res.equipment_name
					});
				})

				this.setState({
					equipment: equipment,
					equipment_ubication: response
				});
			}
		});

	}

	changeEquipment(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		var id = parseInt(e.target.value);

		var index = this.state.equipment_ubication.findIndex(obj => obj.equipment_id === id);

		console.log(index)
		if(index !== undefined){
			this.setState({location: this.state.equipment_ubication[index].ubications});
		}

	
	}

	onSave(){
		var obj = [];
		var list = this.state.list;
		list.map((list)=>
			obj.push({
				storage_ubication_id: list.location_id,
				unit_id: list.unit_id
			})		
		)

		if(obj.length > 0){
			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+'units/set_storage_ubication',{
				method:'post',
				body: JSON.stringify(obj),
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res =>{
				this.props.waiting.handleClose();

				if(res.ok){
					return res.json();
				}else{
					res.text().then(function(result){
						swal("Error", result, 'error');
					});
				}
			}).then(response=>{
				if(response !== undefined){
					swal("Correcto","Registro guardado correctamente.", 'success');
					
					this.onCancel();
				}
			});
			
		}else{
			swal('Error', 'Debe agregar por lo menos un elemento a la lista', 'error');
		}
	}

	onCancel(){
		this.props.history.push('/warehouse/storeUnits');
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		if(input.id === 'requested_by' || input.id === 'requested_to'){
	    			isFormValid = this.getValidationState(input.id);
	    		}else{
	    			const isInputValid = this.showCtrlError(input.name);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
	    		}
	    		
			      			   
		  	}
	    });
	    
	    return isFormValid;
	}

	addToList(){
		if(this.isValidForm()){
			var list = this.state.list;
			var obj = {
				equipment_id:this.state.equipment_id,
				equipment:"",
				location_id: this.state.location_id,
				ubication:"",
				unit_number:this.state.unit_number,
				unit_id:this.state.unit_id,
				code_component:this.state.code_component+' '+this.state.component_number
			};

			var index = this.state.equipment.findIndex(item => item.id === parseInt(this.state.equipment_id));
			if(index !== -1){
				obj.equipment = this.state.equipment[index].name;
			}

			index = this.state.location.findIndex(item => item.id === parseInt(this.state.location_id));
			if(index !== -1){
				obj.ubication = this.state.location[index].name;
			}

			index = list.findIndex(item => 
				//item.equipment_id === parseInt(this.state.equipment_id) &&
				//item.location_id === parseInt(this.state.location_id) &&
				item.unit_id === parseInt(this.state.unit_id)	
			)

			if(index === -1){
				list.push(obj);
				this.setState({
					list: list, 
					unit_number:"",
					unit_id:"",
					code_component:"",
					component_number:"",
					code_component_list:[]
				});

				this._typeahead.getInstance().clear();
				
			}else{
				swal('La unidad ya se encuentra en el listado', 'error');
			}

		}else{
			swal('Error', 'Campos incompletos', 'error');
		}
	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.warehouse.MAIN')} ->
						{t('sidebar.nav.warehouse.storeUnits')}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_storage"} 
		            submenu={"help_units_set_storage"}  />
				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-2">
			        			<span>Equipo:</span>
					        	<select name="equipment_id" className="form-control" id="equipment_id" 
					        		onKeyPress={(e) => this.validateInput(e)} required
					        		value={this.state.equipment_id || ""} 
					        		onChange={this.changeEquipment}>
					        		<option value="">Seleccione...</option>
					        		{this.state.equipment.map((e)=>{
					        			return <option key={e.id} value={e.id}>{e.name}</option>
					        		})}
					        	</select>
					        </div>

							<div className="col-xs-12 col-sm-2">
			        			<span>Ubicación:</span>
					        	<select name="location_id" className="form-control" id="location_id" 
					        		onKeyPress={(e) => this.validateInput(e)} required
					        		value={this.state.location_id || ""} onChange={this.handleChange}>
					        		<option value="">Seleccione...</option>
					        		{this.state.location.map((e)=>
					        			<option key={e.id} value={e.id}>{e.name}</option>
									)}
					        	</select>
					        </div>

							<div className="col-xs-12 col-sm-2">
								<span className="span-min">No de Unidad</span>
								<input className={this.state.unit_number_required ? "form-control error" : "form-control"} type="text" 
									id = "unit_number" name="unit_number" onKeyPress={(e) => this.searchComponent(e)} 
									onChange={this.handleChange} required
									value={this.state.unit_number || ""} />
							</div>

							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Código componente</span>
								<AsyncTypeahead
						          	/*{...this.state}*/
						          	labelKey={(option) => `${option.label}`}
						          	minLength={0}
						          	options={this.state.code_component_list}
						          	onChange={this.onSearch}	
						            inputProps={{
						          		name:"code_component",
						          		required: "required",
						          		id:"code_component"
						          	}}
						          	id="codeComponent"
						          	useCache={false}
						          	ref={ref => this._typeahead = ref}
						          	isLoading={this.state.isLoading}
						          	delay={600}
						          	paginationText="Mostrar mas resultados..."
						        />
						       
							</div>

							<div className="col-xs-12 col-sm-1" style={{paddingTop:"20px"}}>
							  	<FloatingActionButton className="action-btn" mini={true} iconStyle={{height: 23, width: 23}} 
							  		onClick={()=>this.addToList()}>
									<ContentAdd/>
							  	</FloatingActionButton>
							</div>
							
						</div>	

						<hr/>

						<div className="col-xs-12 form-group">
							<Table responsive hover>
								<thead>
									<tr>
										<th>Equipo</th>
										<th>Ubicación</th>
										<th>No. Unidad</th>
										<th>Código de componente</th>
									</tr>
								</thead>
								<tbody>
									{this.state.list.map((list, i)=>
										<tr key={i}>
											<td>{list.equipment}</td>
											<td>{list.ubication}</td>
											<td>{list.unit_number}</td>
											<td>{list.code_component}</td>
										</tr>
									)}
								</tbody>
							</Table>
						</div>

						<div className="col-xs-12" style={{textAlign:'center'}}>
				        	<div>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave}  style={{margin:12}}/>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.onCancel} style={{margin:12}}/>
				        	</div>
				        </div>
												
					</div>


				</form>

				<Notifications />
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(StoreUnits);
